/**
 * Token management utility for handling JWT tokens
 */

const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

export const tokenManager = {
  /**
   * Store token and user data
   */
  setToken: (token, user) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  /**
   * Get stored token
   */
  getToken: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    return token;
  },

  /**
   * Get stored user data
   */
  getUser: () => {
    const userData = localStorage.getItem(USER_KEY);
    if (!userData) return null;
    
    try {
      return JSON.parse(userData);
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  },

  /**
   * Remove token and user data
   */
  clearAuth: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    console.log('Auth data cleared');
  },

  /**
   * Check if user is authenticated
   */
  isAuthenticated: () => {
    const token = tokenManager.getToken();
    const user = tokenManager.getUser();
    return !!(token && user);
  },

  /**
   * Validate token format and expiration
   */
  isTokenValid: (token = null) => {
    const authToken = token || tokenManager.getToken();

    if (!authToken || typeof authToken !== "string") return false;

    const parts = authToken.split(".");
    if (parts.length !== 3) {
      // Opaque access tokens (e.g. Adonis oat_*) — validity checked by the API.
      return authToken.length > 10;
    }

    try {
      const payload = JSON.parse(atob(parts[1]));

      if (payload.exp) {
        const currentTime = Math.floor(Date.now() / 1000);
        if (payload.exp < currentTime) {
          console.log("Token expired");
          return false;
        }
      }

      return true;
    } catch (error) {
      console.error("Token validation error:", error);
      return false;
    }
  }
};
